import { PersonOutline, Archive, Delete, Edit, Phone, Email, School, Payment } from '@material-ui/icons';
import { PLAN_TYPES } from '../../../../../constants';

/**
 * User action identifiers
 */
export const USER_ACTIONS = {
  VIEW_PROFILE: 'View Profile',
  ENROLL_PAYMENT: 'Enroll Payment',
  CHANGE_EMAIL: 'Change Email',
  CHANGE_COHORT: 'Change Cohort',
  CHANGE_NAME: 'Change Name',
  REMOVE_PHONE: 'Remove Phone',
  ARCHIVE: 'Archive',
  UNARCHIVE: 'Unarchive',
  UNENROLL: 'Unenroll',
};

/**
 * Action configuration for Student Operations > All Students
 * 
 * Each action can have:
 * - action: USER_ACTIONS constant (display label)
 * - icon: Material-UI icon component
 * - handler: 'navigate' | 'openModal' | 'api'
 * - handlerConfig: Configuration for the handler
 * - visible: Optional function to determine visibility based on row data
 */
export const USER_ACTION_CONFIG = [
  {
    action: USER_ACTIONS.VIEW_PROFILE,
    icon: PersonOutline,
    handler: 'navigate',
    handlerConfig: {
      path: '/all-users/user-details',
      stateKey: 'userParams',
    },
  },
  {
    action: USER_ACTIONS.ENROLL_PAYMENT,
    icon: Payment,
    handler: 'navigate',
    handlerConfig: {
      path: '/all-users/enroll-payment',
      stateKey: 'userParams',
    },
  },
  {
    action: USER_ACTIONS.CHANGE_EMAIL,
    icon: Email,
    handler: 'openModal',
    handlerConfig: { modal: 'changeEmail' },
  },
  {
    action: USER_ACTIONS.CHANGE_COHORT,
    icon: School,
    handler: 'openModal',
    handlerConfig: { modal: 'changeCohort' },
    visible: (params) =>
      [PLAN_TYPES.MASTERS, PLAN_TYPES.PRO_LIVE].includes(
        params.data.UserSubscriptions_planType
      ),
  },
  {
    action: USER_ACTIONS.CHANGE_NAME,
    icon: Edit,
    handler: 'openModal',
    handlerConfig: { modal: 'changeName' },
    visible: () => true,
  },
  {
    action: USER_ACTIONS.REMOVE_PHONE,
    icon: Phone,
    handler: 'openModal',
    handlerConfig: { modal: 'removePhone' },
    visible: (params) => Boolean(params.data.phone),
  },
  {
    action: USER_ACTIONS.ARCHIVE,
    icon: Archive,
    handler: 'api',
    handlerConfig: {
      endpoint: '/users/archive',
      method: 'POST',
      requiresConfirm: true,
      confirmTitle: 'Archive',
      confirmMessage: 'Are you sure you want to archive this user? They will be moved to archived status.',
      refreshGrid: true,
    },
    visible: (params) => {
      const status = params.data.status || 'Active';
      return !status.toLowerCase().includes('archiv');
    },
  },
  {
    action: USER_ACTIONS.UNARCHIVE,
    icon: Archive,
    handler: 'api',
    handlerConfig: {
      endpoint: '/users/unarchive',
      method: 'POST',
      requiresConfirm: true,
      confirmTitle: 'Unarchive',
      confirmMessage: 'Are you sure you want to unarchive this user? They will be restored to active status.',
      refreshGrid: true,
    },
    visible: (params) => {
      const status = params.data.status || 'Active';
      return status.toLowerCase().includes('archiv');
    },
  },
  {
    action: USER_ACTIONS.UNENROLL,
    icon: Delete,
    handler: 'api',
    danger: true,
    handlerConfig: {
      endpoint: '/users/unenroll',
      method: 'POST',
      requiresConfirm: true,
      confirmTitle: 'Unenroll User',
      confirmMessage:
        'This will soft-delete the user. Enrollment history will be preserved. This action cannot be undone.',
      requiresReason: false,
      refreshGrid: true,
    },
    visible: () => true,
  },
];
